import React, { useRef } from 'react';
import T from 'prop-types';
import isEmpty from 'lodash.isempty';
import { CopyOutlined } from '@ant-design/icons';
import { Input, Tooltip } from 'antd';

import GenerateKeyButton from '../generateKeyButton';

import { StyledCard, InputContainer } from './style';

const ApiKeyCard = ({ apiKey, generateApiKey, pushNotification }) => {
  const apiInputRef = useRef(null);

  const handleCopyText = () => {
    const { input } = apiInputRef.current;

    if (!input || isEmpty(apiKey)) {
      return;
    }

    input.select();
    document.execCommand('copy');

    pushNotification({
      title: 'API key copied to clipboard',
      duration: 6,
      type: 'success',
    });
  };

  return (
    <StyledCard bordered={false} title="Generate API Key">
      <InputContainer>
        <Input
          ref={apiInputRef}
          addonAfter={
            <Tooltip title="Copy API key">
              <CopyOutlined onClick={handleCopyText} />
            </Tooltip>
          }
          placeholder="No API key generated"
          readOnly
          value={apiKey}
        />
      </InputContainer>

      <GenerateKeyButton needsConfirmation={!isEmpty(apiKey)} onClick={generateApiKey} />
    </StyledCard>
  );
};

ApiKeyCard.propTypes = {
  generateApiKey: T.func.isRequired,
  pushNotification: T.func.isRequired,

  apiKey: T.string.isRequired,
};

export default ApiKeyCard;
